<template>
  <!-- Miniature -->
  <div class="product-names" v-if="fileUrl">
    <div class="light-product-box">
      <a 
        href="#" 
        data-bs-toggle="modal" 
        :data-bs-target="'#pieceModal' + keyValue"
      >
        <img 
          :src="imageUrl" 
          class="img-fluid thumbnail" 
          :alt="libelle" 
          @error="handleImageError"
        />
      </a>
    </div>
  </div>

  <!-- Pas de fichier -->
  <div class="product-names" v-else>
    <div class="light-product-box">
      <vue-feather type="camera-off"></vue-feather>
    </div>
  </div>

  <!-- MODAL -->
  <div 
    class="modal fade" 
    :id="'pieceModal' + keyValue" 
    tabindex="-1" 
    aria-labelledby="pieceModalLabel" 
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="pieceModalLabel">{{ libelle }}</h5>
          <button 
            type="button" 
            class="btn-close" 
            data-bs-dismiss="modal" 
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body text-center p-3">
          <inner-image-zoom 
            :src="imageUrl" 
            :zoom-src="imageUrl" 
            zoom-type="hover"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import InnerImageZoom from 'vue-inner-image-zoom';

import { getUrlApiForEtudiantsFiles } from "@/utils/utils";   // ← Import de ta fonction

export default defineComponent({
  name: "ModalPieceEtudiant",
  components: {
    'inner-image-zoom': InnerImageZoom,
    
  },

  props: {
    fileUrl: {
      type: String,
      default: null,
    },
    keyValue: {
      type: [String, Number],
      required: true,
    },
    libelle: {
      type: String,
      default: 'Pièce jointe',
    },
  },

  setup(props) {
    // Utilisation de ta fonction existante (comme dans ModalImage)
    const imageUrl = computed(() => {
      if (!props.fileUrl) {
        return '/default-image.jpg';
      }
      return getUrlApiForEtudiantsFiles(props.fileUrl);
    });

    const handleImageError = (e: Event) => {
      console.error('Erreur chargement image pour la pièce :', imageUrl.value);
      const img = e.target as HTMLImageElement;
      img.src = 'https://via.placeholder.com/400x300?text=Image+non+disponible';
    };

    return {
      imageUrl,
      handleImageError,
    };
  },
});
</script>

<style scoped>
.thumbnail {
  width: 50px;
  height: 50px;
  object-fit: cover;
  cursor: pointer;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}

.thumbnail:hover {
  transform: scale(1.05);
  transition: transform 0.2s ease;
}

.light-product-box {
  padding: 8px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.modal-body {
  padding: 20px;
}

.modal-body img {
  max-height: 70vh;
  object-fit: contain;
}
</style>